import ACLStore from "lib/aclStore";
export const isNewTemplateResolverEnabled = () =>
  ACLStore.can("FeatureFlag:WorkbookTemplateUseNewResolver");
